/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/field-utils";
import { CurrencyFieldDisplay } from "./display";
import { CurrencyFieldEdit } from "./edit";

const CurrencyField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <CurrencyFieldDisplay />,
        editComponent: <CurrencyFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
CurrencyField.displayName = "CurrencyField";
export { CurrencyField };
